<template>
  <!-- TOAST LOADING -->
  <div v-if="toastMsg" class="MIDAS-TOAST-loading">
    <p class="MIDAS-TOAST-loading__txt">{{ toastMsg }}</p>
  </div>
</template>
<script>
export default {
  props: ["toastMsg"]
}
</script>
